import React from "react";
import NoDataFound from "../../common/NoDataFound";

const OffenseDefenseTable = ({ data, active, setActive }) => {
  const tableData = active === "offense" ? data?.offense : data?.defence;
  const isOffense = active === "offense";

  return (
    <div className="league_block">
      <div className="leg_main">
        <div className="leg_head">
          <h2>Offense / Defense</h2>
        </div>
        <nav className="inner_tab">
          <ul>
            {["offense", "defence"].map((key) => (
              <li
                key={key}
                className={active === key ? "active" : ""}
                onClick={() => setActive(key)}
              >
                <span>{key === "offense" ? "Top Offense" : "Top Defense"}</span>
              </li>
            ))}
          </ul>
        </nav>
      </div>
      <div className="global_table striped offense_tbl">
        {tableData?.length ? (
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Team</th>
                <th>{isOffense ? "Goals Per Match" : "Conceded Per Match"}</th>
                <th>{isOffense ? "Goals Scored" : "Conceded Scored"}</th>
              </tr>
            </thead>
            <tbody>
              {tableData?.slice(0, 20).map((team, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>
                    <span className="team_name">{team?.team?.nm}</span>
                  </td>
                  <td>{isOffense ? team?.gpm : team?.cpm}</td>
                  <td>{isOffense ? team?.sc : team?.cn}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <NoDataFound />
        )}
      </div>
    </div>
  );
};

export default OffenseDefenseTable;
